import { ArticleHeading4, ArticleParagraph2 } from '@cian/ui-kit/typography';

import { clsx } from 'clsx';
import { type FC, type ReactElement } from 'react';

import styles from './styles.css';

interface IFlatsErrorProps {
  image: 'not-found' | 'start';
  title: string;
  text: ReactElement | string | null;
}

export const FlatsError: FC<IFlatsErrorProps> = ({ image, text, title }) => (
  <div className={styles['container']}>
    <div className={clsx(styles['image'], styles[image])} />
    <div className={styles['title']}>
      <ArticleHeading4 color="text-primary-default">{title}</ArticleHeading4>
    </div>
    {!!text && (
      <ArticleParagraph2 color={'gray60_100'} data-mark="FlatsErrorText" textAlign={'center'}>
        {text}
      </ArticleParagraph2>
    )}
  </div>
);
